import * as React from "react";
import Modal from "./modal";
import IframeResizer from "iframe-resizer-react";
import { useIntl } from "react-intl";

const BookingModal = ({ isOpen, onClose, triggerRef, urlFillout }) => {
  const { formatMessage } = useIntl();
  const iframeEl = React.useRef(null);
  const utmParams =
    typeof window !== "undefined"
      ? Object.keys(localStorage)
          .filter((key) => key.startsWith("utm_"))
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(
                localStorage.getItem(key)
              )}`
          )
          .join("&")
      : "";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      triggerRef={triggerRef}
      variant="booking"
    >
      {urlFillout ? (
        <IframeResizer
          forwardRef={iframeEl}
          seamless
          style={{ width: "100%", height: "100%" }}
          scrolling="yes"
          frameBorder={0}
          className="rezdy"
          src={`${urlFillout}${utmParams ? `&${utmParams}` : ""}`}
          title={formatMessage({ id: "book" })}
        />
      ) : (
        <p className="unavailable">Pas de dates disponibles</p>
      )}
    </Modal>
  );
};

export default BookingModal;
